import EventHandler from "../dom/event-handler.js";
import SelectorEngine from "../dom/selector-engine.js";
import ScrollSpy from "../scrollspy.js"; // Import your ScrollSpy class

const DATA_KEY = "bs.revealscrollspy";
const EVENT_KEY = `.${DATA_KEY}`;
const DATA_API_KEY = ".data-api";
const EVENT_LOAD_DATA_API = `load${EVENT_KEY}${DATA_API_KEY}`;

const CLASS_NAME_ACTIVE = "active";

const SELECTOR_DATA_SPY = '[data-bs-spy="reveal"]';

const DefaultType = {
	...ScrollSpy.DefaultType,
	section: "(string|boolean)",
	reveal: "(string|boolean)",
};

const Default = {
	...ScrollSpy.Default,
	section: false,
	reveal: false,
};

class RevealScrollSpy extends ScrollSpy {
	constructor(element, config) {
		super(element, config);
	}

	_observerCallback(entries) {
		super._observerCallback(entries);

		entries.forEach((entry) => {
			const section = SelectorEngine.findOne(`#${entry.target.id}`);
			const elements = SelectorEngine.find(
				`.${this._config.reveal}`,
				section,
			);
			if (entry.isIntersecting) {
				const target = this._targetLinks.get(`#${entry.target.id}`);

				if (target && section.classList.contains(this._config.section)) {
					entry.target.classList.add(CLASS_NAME_ACTIVE);
					elements.forEach((element) => element.classList.add("in"));
				}
			} else {
				entry.target.classList.remove(CLASS_NAME_ACTIVE);
				elements.forEach((element) => element.classList.remove("in"));
			}
		});
	}

	static get Default() {
		return Default;
	}

	static get DefaultType() {
		return DefaultType;
	}
}

EventHandler.on(window, EVENT_LOAD_DATA_API, () => {
	for (const spy of SelectorEngine.find(SELECTOR_DATA_SPY)) {
		RevealScrollSpy.getOrCreateInstance(spy);
	}
});

export default RevealScrollSpy;
